import common from "./common";
import noticeMessage from "./noticeMessage";
import business from "./business";

let mqttClient = {
  client: null,
  userId: 0, // 门店ID
  mqttTcpPort: "",
  mqttWsPort: "",
  mqttWssPort: "",
  mqttAddress: "",
  mqttUsername: "",
  mqttPwd: "",
  mqttClientId: "",
  mqttTopicList: [],
}

// mqtt的处理
mqttClient.startMqtt = () => {

  if (typeof mqttClient.client === "undefined") {
    mqttClient.client = null
  }

  if (mqttClient.client != null) {
    mqttClient.client.end();
  }

  // 没有门店ID
  if(!mqttClient.userId) {
    return;
  }

  // 没有地址
  if(!mqttClient.mqttAddress) {
    return;
  }

  // mqtt的连接的地址
  var connectUrl = "";

  // 如果是https的，则用wss；否则用ws
  if (window.location.protocol === "https:") {
    // wss://push.ku52.cn:9884/
    connectUrl = "wss://" + mqttClient.mqttAddress + ":" + mqttClient.mqttWssPort + "/"
  } else {
    // ws://push.ku52.cn:9885/
    connectUrl = "ws://" + mqttClient.mqttAddress + ":" + mqttClient.mqttWsPort + "/"
  }

  var username = mqttClient.mqttUsername; // 用户名
  var password = mqttClient.mqttPwd; // 密码

  var options = {
    keepalive: 30,
    clientId: mqttClient.mqttClientId,
    // protocolId: 'MQTT',
    // protocolVersion: 4,
    // clean: false,
    clean: true, // 20211010: 因为酷鼠助手每次双击都会打开新的浏览器，localstorage相同，目前这里的clean为true，丢失的通知不管，且设备标识就用随机的在SessionStorage
    reconnectPeriod: 1000,
    connectTimeout: 30 * 1000,
    username: username, // 字符串类型 用设备标识作为用户名
    password: password,
    will: {
      topic: '/will',
      payload: 'Connection Closed abnormally.',
      qos: 0,
      retain: false
    },
    rejectUnauthorized: false
  }

  mqttClient.client = window.mqtt.connect(connectUrl, options)

  mqttClient.client.on('connect', (() => {
    console.log("mqtt: 连接成功");

    // 主题
    for (let i = 0; i < mqttClient.mqttTopicList.length; i++) {
      let tempTopic = mqttClient.mqttTopicList[i]

      mqttClient.client.subscribe(tempTopic, {qos: 1});
    }
  }))

  mqttClient.client.on('message', function (topic, message) {
    var msg = JSON.parse(message.toString())

    // 正式版上的通知的格式，已修改，不使用
    if (typeof msg.payload == "undefined") {
      return;
    }

    var data = msg.payload; // 原来v1版本里，websocket通知的内容

    //判断需要拉取的值
    var type = data.content;

    console.log(common.dateFormat(new Date(), 'hh:ii:ss') + ' mqtt:' + type);

    noticeMessage.messageQueue.push({
      'type': type,
      'tag': '',
      'businessTag': "",
    });
  })

  /**
   * 1、前端连好，主动断开，触发的是：
   *  先是close，再是end
   *
   * 2、在连接的时候，连不上地址，触发的是：
   *  假的不可访问的地址，触发的是end事件
   *  真的可访问的，但是不能操作的，触发的: --- 给的是正确的地址，只是将端口号从9884改为9883
   *          先是offline，然后是close
   *          然后自动重试的过程中，一直是close
   *
   * 3、在连接成功后，因为服务端连不上了，触发的是？
   *  先是offline，然后是close
   *  接着一直是close --- 应该是mqtt的自动重连的
   *
   *  这个过程里，如果一旦mqtt又可以访问了，会自动连上的
   *
   * 4、在正常使用过程中，会重连，是因为什么？ --- 原因不清楚
   *  会自己触发offline，然后是close，然后又重连上了
   *
   */

  // end事件 -- 主动断开也会触发这个；连接的时候地址是错的连不上，也会触发
  mqttClient.client.on('end', function () {
    console.log("mqtt end")

  })

  // 在连接时失败触发的
  mqttClient.client.on("error", function (e) {
    console.log("mqtt error")

  })

  mqttClient.client.on("close", function (e) {
    console.log("mqtt close")

  })

  // offline，不要，因为offline之后，跟着close

}

export default mqttClient;